import cloneDeep from 'lodash/cloneDeep';

import { initialProfile } from './profile';
import type { Profile } from './profile';

export const mapProfile = ({
    ADDRESS_ROOM,
    ADDRESS_STREET,
    ALTEMAIL,
    CITY,
    COMPANY_NAME,
    confirm_type,
    COUNTRY,
    device_confirmed,
    name,
    email,
    FIRST_NAME,
    INN,
    KPP,
    LAST_NAME,
    MIDDLE_NAME,
    OGRN,
    PHONE,
    restricted,
    SAME_POSTAL,
    SEX,
    SKYPE,
    TYPE,
    USER_ID,
    user_status,
    WEB,
    ZIP,
    userRole,
    userId,
    superadmin,
    superadminUser,
    superadminPermission,
}: any): Profile => ({
    ...cloneDeep(initialProfile),
    id: USER_ID,
    type: TYPE,
    userId: userId,

    restricted,
    userStatus: user_status,
    deviceConfirmed: device_confirmed,
    confirmType: confirm_type,

    surname: LAST_NAME,
    name: FIRST_NAME,
    patronymic: MIDDLE_NAME,
    nikname: name,

    sex: Boolean(Number(SEX)),

    website: WEB,
    phone: PHONE,
    email,
    altEmail: ALTEMAIL,
    userRole,
    skype: SKYPE,

    companyName: COMPANY_NAME,
    inn: INN || '',
    kpp: KPP || '',
    ogrn: OGRN || '',

    mailMatch: SAME_POSTAL,
    country: COUNTRY,
    zipCode: ZIP,
    city: CITY,
    street: ADDRESS_STREET,
    room: ADDRESS_ROOM,
    superadmin,
    superadminUser,
    superadminPermission,
});

export const reverseMapProfile = (profile: Profile): any => ({
    USER_TYPE: profile.type,

    FIRST_NAME: profile.name,
    LAST_NAME: profile.surname,
    MIDDLE_NAME: profile.patronymic,
    name: profile.nikname,

    SEX: profile.sex ? 1 : 0,

    WEB: profile.website,
    PHONE: profile.phone,
    ALTEMAIL: profile.email,
    SKYPE: profile.skype,

    COMPANY_NAME: profile.companyName,
    INN: profile.inn,
    KPP: profile.kpp,
    OGRN: profile.ogrn,

    COUNTRY: profile.country,
    ZIP: profile.zipCode,
    CITY: profile.city,
    ADDRESS_STREET: profile.street,
    ADDRESS_ROOM: profile.room,
});
